import { DownloadsModel, GeneralModel, StatisticsModel } from '../../models';

export enum ActionType {
  FETCH_WFM_EXPANDED_WORKERS_ONSITE_START = '[dashboard] fetch wfm expanded workers onsite start',
  FETCH_WFM_EXPANDED_WORKERS_ONSITE_SUCCESS = '[dashboard] fetch wfm expanded workers onsite success',
  FETCH_WFM_EXPANDED_COMPANIES_ONSITE_START = '[dashboard] fetch wfm expanded companies onsite start',
  FETCH_WFM_EXPANDED_COMPANIES_ONSITE_SUCCESS = '[dashboard] fetch wfm expanded companies onsite success',
  FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE_START = '[dashboard] fetch wfm expanded workers for company onsite start',
  FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE_SUCCESS = '[dashboard] fetch wfm expanded workers for company onsite success',
  FETCH_WFM_EXPANDED_TRADES_ONSITE_START = '[dashboard] fetch wfm expanded trades onsite start',
  FETCH_WFM_EXPANDED_TRADES_ONSITE_SUCCESS = '[dashboard] fetch wfm expanded trades onsite success',
  FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE_START = '[dashboard] fetch wfm expanded workers for trade onsite start',
  FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE_SUCCESS = '[dashboard] fetch wfm expanded workers for trade onsite success',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES_START = '[dashboard] fetch daily log expanded total trades start',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES_SUCCESS = '[dashboard] fetch daily log expanded total trades success',
  FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE_START = '[dashboard] fetch daily log expanded workers for total trade start',
  FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE_SUCCESS = '[dashboard] fetch daily log expanded workers for total trade success',
  FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED_START = '[dashboard] fetch daily log expanded new workers badged start',
  FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED_SUCCESS = '[dashboard] fetch daily log expanded new workers badged success',
  FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED_START = '[dashboard] fetch daily log expanded new companies enrolled start',
  FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED_SUCCESS = '[dashboard] fetch daily log expanded new companies enrolled success',
  FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY_START = '[dashboard] fetch daily log expanded workers for new company start',
  FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY_SUCCESS = '[dashboard] fetch daily log expanded workers for new company success',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT_START = '[dashboard] fetch daily log expanded total headcount start',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT_SUCCESS = '[dashboard] fetch daily log expanded total headcount success',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES_START = '[dashboard] fetch daily log expanded total companies start',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES_SUCCESS = '[dashboard] fetch daily log expanded total companies success',
  FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY_START = '[dashboard] fetch daily log expanded workers for total company start',
  FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY_SUCCESS = '[dashboard] fetch daily log expanded workers for total company success',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS_START = '[dashboard] fetch daily log expanded total onsite hours start',
  FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS_SUCCESS = '[dashboard] fetch daily log expanded total onsite hours success',
  EXPORT_WIDGET_DATA_START = '[dashboard] export widget data start',
  FETCH_IN_PROGRESS_WIDGET_EXPORTS_START = '[dashboard] fetch in-progress widget exports start',
  FETCH_IN_PROGRESS_WIDGET_EXPORTS_SUCCESS = '[dashboard] fetch in-progress widget exports success',
}

export const actions = {
  fetchWfmExpandedWorkersOnsiteStart: (query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_WFM_EXPANDED_WORKERS_ONSITE_START, payload: { query } }),
  fetchWfmExpandedWorkersOnsiteSuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_WFM_EXPANDED_WORKERS_ONSITE_SUCCESS,
    payload: { workers },
  }),
  fetchWfmExpandedCompaniesOnsiteStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_WFM_EXPANDED_COMPANIES_ONSITE_START,
    payload: { query },
  }),
  fetchWfmExpandedCompaniesOnsiteSuccess: (companies: StatisticsModel.IExpandedCompaniesOnsiteResponse) => ({
    type: ActionType.FETCH_WFM_EXPANDED_COMPANIES_ONSITE_SUCCESS,
    payload: { companies },
  }),
  fetchWfmExpandedWorkersForCompanyOnsiteStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE_START,
    payload: { query },
  }),
  fetchWfmExpandedWorkersForCompanyOnsiteSuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE_SUCCESS,
    payload: { workers },
  }),
  fetchWfmExpandedTradesOnsiteStart: (query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_WFM_EXPANDED_TRADES_ONSITE_START, payload: { query } }),
  fetchWfmExpandedTradesOnsiteSuccess: (trades: StatisticsModel.IExpandedTradesOnsiteResponse) => ({
    type: ActionType.FETCH_WFM_EXPANDED_TRADES_ONSITE_SUCCESS,
    payload: { trades },
  }),
  fetchWfmExpandedWorkersForTradeOnsiteStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE_START,
    payload: { query },
  }),
  fetchWfmExpandedWorkersForTradeOnsiteSuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE_SUCCESS,
    payload: { workers },
  }),
  fetchDailyLogExpandedTotalTradesStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES_START,
    payload: { query },
  }),
  fetchDailyLogExpandedTradesOnsiteSuccess: (trades: StatisticsModel.IExpandedTradesOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES_SUCCESS,
    payload: { trades },
  }),
  fetchDailyLogExpandedWorkersForTotalTradeStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE_START,
    payload: { query },
  }),
  fetchDailyLogExpandedWorkersForTotalTradeSuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE_SUCCESS,
    payload: { workers },
  }),
  fetchDailyLogExpandedNewWorkersBadgedStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED_START,
    payload: { query },
  }),
  fetchDailyLogExpandedNewWorkersBadgedSuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED_SUCCESS,
    payload: { workers },
  }),
  fetchDailyLogExpandedNewCompaniesEnrolledStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED_START,
    payload: { query },
  }),
  fetchDailyLogExpandedNewCompaniesEnrolledSuccess: (companies: StatisticsModel.IExpandedCompaniesOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED_SUCCESS,
    payload: { companies },
  }),
  fetchDailyLogExpandedWorkersForNewCompanyStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY_START,
    payload: { query },
  }),
  fetchDailyLogExpandedWorkersForNewCompanySuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY_SUCCESS,
    payload: { workers },
  }),
  fetchDailyLogExpandedTotalHeadcountStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT_START,
    payload: { query },
  }),
  fetchDailyLogExpandedTotalHeadcountSuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT_SUCCESS,
    payload: { workers },
  }),
  fetchDailyLogExpandedTotalCompaniesStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES_START,
    payload: { query },
  }),
  fetchDailyLogExpandedTotalCompaniesSuccess: (companies: StatisticsModel.IExpandedCompaniesOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES_SUCCESS,
    payload: { companies },
  }),
  fetchDailyLogExpandedWorkersForTotalCompanyStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY_START,
    payload: { query },
  }),
  fetchDailyLogExpandedWorkersForTotalCompanySuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY_SUCCESS,
    payload: { workers },
  }),
  fetchDailyLogExpandedTotalOnsiteHoursStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS_START,
    payload: { query },
  }),
  fetchDailyLogExpandedTotalOnsiteHoursSuccess: (workers: StatisticsModel.IExpandedWorkersOnsiteResponse) => ({
    type: ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS_SUCCESS,
    payload: { workers },
  }),
  exportWidgetDataStart: (query: { createExportRequest: StatisticsModel.IExportRequest }, widget?: string) => ({
    type: ActionType.EXPORT_WIDGET_DATA_START,
    payload: { query, widget },
  }),
  fetchInProgressWidgetExportsStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_IN_PROGRESS_WIDGET_EXPORTS_START,
    payload: { query },
  }),
  fetchInProgressWidgetExportsSuccess: (inProgressExports: any) => ({
    type: ActionType.FETCH_IN_PROGRESS_WIDGET_EXPORTS_SUCCESS,
    payload: { inProgressExports },
  }),
};
